export default __webpack_public_path__ + "static/media/sh-reply-disabled.d27630cb.svg";